<template>
  <div class="index-page">
    <Header />
    <router-view />
    <Foot />
  </div>
</template>

<script>
import Header from './libs/Header';
import Foot from './libs/Foot';
export default {
  name: 'Main',
  data() {
    return {
      loading: false,
      homenoticelis: [],
      loginInfo: {},
      registerInfo: {},
      pay_way: 0,
      amount: null, //虚拟币充值金额
      meyXi: 'ERC20', //qian
      xiyiShow: false,
      bankBox: {},
      step: 1,
      payInfo: {},
      cardLis: [],
      banklist: [],
      usdssLis: [],
      usercardLis: [],
      qutype: 0,
      bankId: null,
      password: null,
      daoTime: null,
      balancelist: [],
      balancelists: [],
      sourcetype: null,
      targettype: null,
      cardInfo: { bank: null },
    };
  },
  components: {
    Header,
    Foot,
  },
  created() {
    let that = this;
    that.homenotice(); //获取公告
    that.getBanklist();
    that.getcard();
    that.getUsercard();
    that.getUsdssList();
    that.baseURL = sessionStorage.getItem('baseURL') || '';
  },
  updated() {
    let that = this;
  },
  mounted() {
    let that = this;
  },
  methods: {
    outLogin() {
      let that = this;
      that.$parent.outLogin();
    },
    focusTab(name) {
      focusTab(name);
      let nas = '#nav-' + name;
      $(nas).addClass('active').addClass('show');
      $(nas).siblings().removeClass('active').removeClass('show');
    },
    close() {
      let that = this;
      if (that.daoTime) {
        clearInterval(that.daoTime);
      }
      that.daoTime = null;
    },
    openZhuanzhang() {
      let that = this;
      focusTab('transfer');
      //   show
      $('#nav-transfer').addClass('active').addClass('show');
      $('#nav-transfer').siblings().removeClass('active').removeClass('show');
      that.getbalancelists();
      if (sessionStorage.getItem('token')) {
        that.daoTime = setInterval(() => {
          that.getbalancelist();
        }, 4000);
      }
    },
    isOk() {
      let that = this;
      let info = { amount: that.amount, sourcetype: that.sourcetype, targettype: that.targettype };
      if (that.amount == null) {
        that.showTost(0, that.$t('main.amount'));
        return;
      }

      that.showLoading();
      that.$apiFun.post('/api/transfer', info).then(res => {
        that.showTost(1, res.message);

        if (res.code === 200) {
          that.refreshusermoney();
          that.getbalancelists();
          that.amount = null;
          that.sourcetype = null;
          that.targettype = null;
        } else {
          that.hideLoading();
        }
      });
    },
    changVal(type, platname) {
      let that = this;
      if (type == 0) {
        //转入游戏
        that.sourcetype = 'userbalance';
        that.targettype = platname;
      } else {
        //转入平台
        that.sourcetype = platname;
        that.targettype = 'userbalance';
      }
    },
    getbalancelists() {
      let that = this;
      that.showLoading();

      that.$apiFun
        .post('/api/balancelist', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            let resData = res.data;
            let balancelists = res.data;
            balancelists.unshift({ platname: 'userbalance', name: that.$t('main.wallet') });
            resData.forEach(element => {
              element.balance = '读取中..';
            });
            that.balancelist = resData;

            that.balancelists = balancelists;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getbalancelist() {
      let that = this;
      that.$apiFun
        .post('/api/balancelist2', {})
        .then(res => {
          if (res.code !== 200) {
            that.showTost(0, res.message);
          }
          if (res.code === 200) {
            that.balancelist = res.data;
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    refreshusermoney() {
      let that = this;
      that.$apiFun.post('/api/refreshusermoney', {}).then(res => {
        that.hideLoading();
        if (res.code == 200) {
          localStorage.setItem('userInfo', JSON.stringify(res.data));
          that.$store.commit('changUserInfo');
        }
      });
    },
    transall() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/transall', {})
        .then(res => {
          that.showTost(1, res.message);
          that.refreshusermoney();
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changeTasfer() {
      let that = this;
      that.showLoading();
      let userInfo = JSON.parse(localStorage.getItem('userInfo'));
      let mianzhuan = userInfo.transferstatus ? 0 : 1;

      that.$apiFun
        .post('/api/uptransferstatus', { transferstatus: mianzhuan })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            userInfo.transferstatus = mianzhuan;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
            that.showTost(1, that.$t('main.withdrawal'));
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getBalances() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/balance', {})
        .then(res => {
          if (res.code == 200) {
            let userInfo = JSON.parse(localStorage.getItem('userInfo'));
            userInfo.balance = res.data.balance;
            userInfo.gameblance = res.data.gameblance;
            localStorage.setItem('userInfo', JSON.stringify(userInfo));
            that.$store.commit('changUserInfo');
          }
          that.hideLoading();
        })
        .catch(res => {
          // console.log(res)
          that.hideLoading();
        });
    },
    getUsercard() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 1 }).then(res => {
        if (res.code == 200) {
          that.usercardLis = res.data;
        }
      });
    },
    withdraw() {
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;

      if (amount < 100) {
        that.showTost(0, that.$t('main.withdrawal'));
        return;
      }
      if (!bank) {
        that.showTost(0, that.$t('main.select'));
        return;
      }
      if (!password) {
        that.showTost(0, that.$t('main.enter'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, that.$t('main.successfully'));

            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/fundingRecords' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    withdraw1() {
      //  amount: "100"
      // bank: 163
      // bank_owner: "TRC20"
      // password: "1"
      let that = this;
      // amount	是	float	金额
      // bank	是	int	提现银行卡id
      let bank = that.bankId;
      let amount = that.amount;
      let password = that.password;
      if (!bank) {
        that.showTost(0, that.$t('main.address'));
        return;
      }
      if (amount < 100) {
        that.showTost(0, that.$t('main.withdrawal'));
        return;
      }

      if (!password) {
        that.showTost(0, that.$t('main.enter'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/withdraw', { amount, bank, password })
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.showTost(1, that.$t('main.successfully'));
            that.chanmeyXi = null;
            that.amount = null;
            that.password = null;
            that.bank = null;
            setTimeout(() => {
              that.$router.push({ path: '/fundingRecords' });
            }, 1500);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    changqutype(val) {
      let that = this;
      if (that.qutype == val) {
        return;
      }
      that.qutype = val;
      that.amount = null;
      that.password = null;
      that.bankId = null;
    },
    payTest() {
      let that = this;
      let pay_way_arr = ['usdt', 'bank', 'alipay', 'wxpay'];
      let info = {};

      // bank 情况下  bank  bank_address  bank_no  bank_owner
      if (pay_way_arr[that.pay_way] == 'bank') {
        info = {
          paytype: pay_way_arr[that.pay_way],
          amount: that.amount * 1,
          bank: that.bankBox.bank,
          bank_address: that.bankBox.bank_address,
          bank_no: that.bankBox.bank_no,
          bank_owner: that.bankBox.bank_owner,
        };
        console.log(info);
        // 银行卡信息内容的限制
        if (!info.bank_owner) {
          that.showTost(0, that.$t('main.name'));
          return;
        }
        if (!info.bank) {
          that.showTost(0, that.$t('main.type'));
          return;
        }

        if (!info.bank_no) {
          that.showTost(0, that.$t('main.number'));
          return;
        }
        if (!info.bank_address) {
          that.showTost(0, that.$t('main.account'));
          return;
        }
      } else {
        //暂时
        info = {
          paytype: pay_way_arr[that.pay_way],
          amount: that.amount * 1,
        };
      }
      if (pay_way_arr[that.pay_way] == 'usdt') {
        info.catepay = that.meyXi;
      }
      // usdt 情况下  catepay 必填

      // 支付的金额判断
      if (info.amount <= 0) {
        that.showTost(0, that.$t('main.correct'));
        return;
      }
      that.showLoading();
      that.$apiFun
        .post('/api/recharge', info)
        .then(res => {
          console.log(res);
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.amount = null;
            if (pay_way_arr[that.pay_way] == 'bank') {
              that.showTost(1, that.$t('main.successfully'));
              that.bankBox = {};
              that.amount = null;
              $('.modal-backdrop').fadeOut(300);
              $('#deposit_popup').fadeOut(300);
              that.hideLoading();

              return;
            }
            that.bankBox = {};
            that.amount = null;
            that.showTost(1, that.$t('main.Jumping'));

            const routeData = this.$router.resolve({
              path: '/payInfo',
              query: { deposit_no: res.message },
            });

            window.open(routeData.href, '_blank');
            $('.modal-backdrop').fadeOut(300);

            $('#deposit_popup').fadeOut(300);
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },

    homenotice() {
      let that = this;
      that.$apiFun.post('/api/homenotice', {}).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.homenoticelis = res.data;
        }
      });
    },
    getAgentLoginUrl() {
      let that = this;
      that.showTost(1, that.$t('main.going'));
      let pathInfo = this.$router.resolve({
        path: '/gamePage',
        query: {
          dailiD: 1,
        },
      });
      window.open(pathInfo.href, '_blank');
    },
    openDaoTime() {
      this.$parent.openDaoTime();
    },
    closeDaoTime() {
      this.$parent.closeDaoTime();
    },

    openGamePage(name, type, code) {
      let that = this;
      let token = sessionStorage.getItem('token') ? sessionStorage.getItem('token') : '';
      if (!token) {
        that.$router.push({ path: '/login' });
        return;
      }
      that.showTost(1, that.$t('main.open'));
      type = type == null ? 0 : type;
      let pathInfo = this.$router.resolve({
        path: '/gamePage',
        query: {
          name,
          type,
          code,
        },
      });
      window.open(pathInfo.href, '_blank');
    },

    goNav(url) {
      let that = this;
      that.$parent.goNav(url);
    },

    getUserInfo() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(0, res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
        }
      });
    },
    getUserInfos() {
      let that = this;
      that.$apiFun.post('/api/user', {}).then(res => {
        console.log(res);
        if (res.code !== 200) {
          that.showTost(0, res.message);
        }
        if (res.code === 200) {
          let userInfo = res.data;
          let str = userInfo.current_vip;
          let index = str.indexOf('P');
          let vip = str.substr(index + 1, str.length); //04
          userInfo.vip = vip;
          localStorage.setItem('userInfo', JSON.stringify(userInfo));
          that.userInfo = userInfo;
          that.$store.commit('changUserInfo');
          $('#login_popup').modal('hide');
          $('#register_popup').modal('hide');
          that.loginInfo.password = null;
          that.registerInfo = {};
        }
        that.hideLoading();
      });
    },

    getBanklist() {
      let that = this;
      that.$apiFun
        .post('/api/banklist', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.banklist = res.data;
          }
          that.hideLoading();
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    getUsdssList() {
      let that = this;
      that.$apiFun.post('/api/getcard', { type: 2 }).then(res => {
        if (res.code == 200) {
          that.usdssLis = res.data;
        }
      });
    },
    getcard() {
      let that = this;
      that.showLoading();
      that.$apiFun
        .post('/api/getpaybank', {})
        .then(res => {
          if (res.code != 200) {
            that.showTost(0, res.message);
          }
          if (res.code == 200) {
            that.cardLis = res.data;

            that.hideLoading();
          }
        })
        .catch(res => {
          that.hideLoading();
        });
    },
    doCopy(msg) {
      let that = this;
      let cInput = document.createElement('input');
      cInput.style.opacity = '0';
      cInput.value = msg;
      document.body.appendChild(cInput);
      // 选取文本框内容
      cInput.select();

      // 执行浏览器复制命令
      // 复制命令会将当前选中的内容复制到剪切板中（这里就是创建的input标签）
      // Input要在正常的编辑状态下原生复制方法才会生效
      document.execCommand('copy');

      // 复制成功后再将构造的标签 移除
      this.showTost(1, that.$t('main.Copy'));
    },
    showxiyiShow() {
      this.xiyiShow = !this.xiyiShow;
    },
    // 钱包协议的选择
    changMeyXi(val) {
      let that = this;
      this.meyXi = val;
    },

    getpayinfo(deposit_no) {
      let that = this;
      that.$apiFun.post('/api/payinfo', { deposit_no }).then(res => {
        console.log(res);
        if (res.code != 200) {
          that.showTost(0, res.message);
        }
        if (res.code == 200) {
          that.payInfo = res.data;
          that.step = 2;
        }

        that.hideLoading();
      });
    },
    changPayway(val) {
      let that = this;
      if (val == that.pay_way) {
        return;
      }
      that.pay_way = val;
      that.bankBox = {};
      that.step = 1;
      that.payInfo = {};
      that.amount = null;
    },
    newgoNav(url, type) {
      let that = this;
      if (that.path == url) {
        if (type == 1) {
          $('#add_bankcard').addClass('active').addClass('delay');
        } else {
          $('#add_bankcards').addClass('active').addClass('delay');
        }
      } else {
        $('.modal').modal('hide');
        that.goNav(url);
      }
    },
    showLoading() {
      this.$parent.showLoading();
    },
    hideLoading() {
      this.$parent.hideLoading();
    },
    clearUser() {
      this.$parent.clearUser();
    },

    openKefu() {
      this.$parent.openKefu();
    },
    showTost(type, title) {
      this.$parent.showTost(type, title);
    },
  },
  beforeDestroy() {
    let that = this;
    if (that.daoTime) {
      clearInterval(that.daoTime);
    }
    that.daoTime = null;
  },
  watch: {
    //监听路由地址的改变
    $route: {
      immediate: true,
      handler() {
        let that = this;
        that.path = this.$route.path;
      },
    },
  },
};
</script>

<style lang="scss" scoped>
// @import '../../static/css/announcement_modal.css';
</style>



// WEBPACK FOOTER //
// src/components/Main.vue